import { render } from "./sidebnr.vue?vue&type=template&id=7c4a7e56&scoped=true"
import script from "./sidebnr.vue?vue&type=script&lang=js"
export * from "./sidebnr.vue?vue&type=script&lang=js"

import "./sidebnr.vue?vue&type=style&index=0&id=7c4a7e56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4a7e56"]])

export default __exports__